<section class="shopee-lazada-wrapper">
  <div class="box">
    <div class="box__left">
      <h1 class="box__heading color-gray box__heading {{ translate.currentLang }}"
        >{{ 'SHOPEE_LAZADA.INTRO.HEADING' | translate }}
      </h1>

      <!-- list detail heading -->
      <div class="box__heading-detail-list" [innerHTML]="'SHOPEE_LAZADA.INTRO.DETAIL' | translate"> </div>

      <div class="btn-wrapper">
        <a
          class="btn-try-free"
          href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register"
          aria-label="link register try FlowAccount for free"
          (click)="setCookiePreviousPath()"
        >
          {{ 'SHOPEE_LAZADA.INTRO.BTN_REGISTER_FOR_FREE' | translate }}
        </a>
      </div>
    </div>
    <div class="box__right">
      <picture>
        <source
          srcset="
            https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section1/Lazada_Shopee_FlowAccount_v3.webp
          "
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section1/Lazada_Shopee_FlowAccount_v3.jpg"
          width="100%"
          loading="eager"
          alt="{{ getAltText }}"
          class="box__image"
        />
      </picture>
    </div>
  </div>
</section>
